import React, { useState, useEffect, useContext, useRef } from "react";
import quizThumb from '../assets/images/quiz-default.jpg';
import Footer from "../components/footer/Footer";
import SideMenu from "./student/SideMenu";
import Header from "../components/dashboard/header";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import moment from "moment";
import tmdbApi from "../api/tmdbApi";
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import parse from "react-html-parser";
import { Gallery } from "react-grid-gallery";
import Lightbox from "react-image-lightbox";
import "react-image-lightbox/style.css";
import { contentContext } from "../context/contentContext";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import "react-lazy-load-image-component/src/effects/blur.css";
import Loader from "../components/loader";
import OpenSeadragon from "openseadragon";
import deepZoom from "../assets/images/icons/Dna-dz.svg";
import Editor from 'react-simple-wysiwyg';
import { ToastContainer, toast } from 'react-toastify';

const EditFellowshipModule = ({ }) => {

    let { id } = useParams();
    const location = useLocation();
    const moduleType = location.state?.moduleType;

    const transformRef = useRef(null);
    const viewerRef = useRef(null);
    const [resetpopup, setresetpopup] = useState(false);
    const [rotation, setRotation] = useState(0);
    const { state } = useLocation();
    const navigate = useNavigate();
    const [cpcQtns, setCpcQtns] = useState(null);
    const [answers, setAnswersData] = useState(null);
    const [qdisplay, setQdisplay] = useState(false);
    const [imageCloudfront, setImg] = useState("");
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [popupImage, setPopupImage] = useState("");
    const [isPopupLoading, setPopupLoading] = useState(false);
    const [img, setImage] = useState("");
    const [popup, setPopup] = useState(false)
    const [casesList, setCasesList] = useState([]);       // final merged list
    const [loader, setLoader] = useState(false);

    const handleClosePopup = () => { setActiveFeedbackModal(false); setFeedBackData({}) };

    const [index, setIndex] = useState(-1);
    const [gallery, setGallery] = useState([]);
    const [currentImage, setcurrentImage] = useState(null);

    // const [isLoading, setIsLoading] = useState(true);

    const [learninguniqueid, setLearninguniqueid] = useState(null);
    const [selected, setSelected] = useState({});
    const [successMsg, setSuccessMsg] = useState(false)
    const [handleBackPopup, setHandleBackPopup] = useState(false)
    const [viewer, setViewer] = useState(null);

    const [dziUrl, setDziUrl] = useState("");
    const [btnLoader, setBtnLoader] = useState(false);

    const [dziUrlFile, setDziUrlFile] = useState("");
    const [dzipopupImage, setDZIPopupImage] = useState(false);

    const [imageDimensions, setImageDimensions] = useState({ width: 0, height: 0 });
    const [ActiveCaseId, setActiveCaseId] = useState("");

    const [showImagePopup, setShowImagePopup] = useState(false);
    const [activeFeedbackModal, setActiveFeedbackModal] = useState(false);
    const [popupPngImage, setPopupPngImage] = useState("");
    const [feedbackText, setFeedbackText] = useState("");
    const [errorMsg, setErrorMsg] = useState("");
    const [loading, setLoading] = useState(false);

    const [feedbackLoading, setFeedbackLoading] = useState(false); // NEW

    const [showVideoPopup, setShowVideoPopup] = useState(false);
    const [feedBackData, setFeedBackData] = useState({});
    const [quizResultData, setQuizResultData] = useState([]);
    const { searchedFlag, setSearchedFlag, isLoading, setIsLoading, userData, setUserData, activeMenuObj, setActiveMenuObj, sortTableAlpha, arrow, usersearch, setUserSearch, currentPage, setcurrentPage, data, setData, rowsPerPage, setRowsPerPage, currentPageNew, setCurrentPage, route, setRoute, usePrevious, setActiveMenuId, GetTimeActivity } = useContext(contentContext)
    const [error, setError] = useState([])

    const [saveLoader, setSaveLoader] = useState(false);
    const [submitLoader, setSubmitLoader] = useState(false);
    const [confirmPopup, setConfirmPopup] = useState(false);


    const handleFeedbackChange = (e) => {
        setFeedbackText(e.target.value);
        if (errorMsg) setErrorMsg("");
    };

    const onReset = (e) => {
        window.scrollTo(0, 0);
        e.preventDefault()
        setresetpopup(true)
        setCaseAnswers({});
        // setSelected({})
    };

    const [caseAnswers, setCaseAnswers] = useState({});

    // Initialize answers from API data when quizResultData loads
    // useEffect(() => {
    //     if (quizResultData?.cases) {
    //         const initialAnswers = {};
    //         quizResultData.cases.forEach(caseItem => {
    //             const userAnswer = caseItem.answers.find(ans => ans.hasOwnProperty('isCorrect'));
    //             initialAnswers[caseItem.caseid] = userAnswer?.answer || "";
    //         });
    //         setCaseAnswers(initialAnswers);
    //     }
    // }, [quizResultData]);

    useEffect(() => {
        if (quizResultData?.cases) {
            const initialAnswers = {};
            quizResultData.cases.forEach(caseItem => {
                // Take first answer directly
                initialAnswers[caseItem.caseid] =
                    caseItem.answers?.[0]?.answer || "";
            });
            setCaseAnswers(initialAnswers);
        }
    }, [quizResultData]);


    const handleTextInputChange = (caseid, value) => {
        setCaseAnswers(prev => ({
            ...prev,
            [caseid]: value
        }));
    };
    // ----------------------
    //  SUBMIT HANDLER
    // ----------------------
    const handleFeedbackSubmit = async () => {
        if (!feedbackText.trim()) {
            setErrorMsg("Feedback is required");
            return;
        }

        setLoading(true);
        try {
            const payload = {
                feedbackDescription: feedbackText,
                moduleid: id,
                caseid: ActiveCaseId,
            };

            const isUpdate = feedBackData && feedBackData._id;
            const res = await tmdbApi.addFeedback(payload, isUpdate);

            // success reset
            setFeedbackText("");
            setErrorMsg("");
            setActiveCaseId("");
            handleClosePopup();
        } catch (err) {
            console.error("Error submitting feedback:", err.response?.data || err.message);
            setErrorMsg("Failed to submit. Try again.");
        } finally {
            setLoading(false);
        }
    };


    const onConfirmPopup = async (e) => {
        setConfirmPopup(false)
        handleSubmit();

    }
    const onCancelConfirm = (e) => {
        setConfirmPopup(false)

    }

    const onResetConfirm = async (e) => {
        setresetpopup(false)
        setSelected({})
        // fetchData();

    }
    const onResetReject = (e) => {
        setresetpopup(false)
        setError([])
    }

    const handleClearInput = (qIndex, dropdownIdx = 0) => {
        setSelected(prev => ({
            ...prev,
            [`${qIndex}_${dropdownIdx}`]: null
        }));

        let rmpQtns = [...cpcQtns];
        if (rmpQtns[qIndex].answers && rmpQtns[qIndex].answers[dropdownIdx]) {
            rmpQtns[qIndex].answers[dropdownIdx].selected = null;
        }
        setCpcQtns(rmpQtns);
    };
    useEffect(() => {
        if (!viewerRef.current) return;

        console.log("Loading OpenSeadragon with URL:", dziUrl);
        const isDziURL = dziUrl.includes("output.dzi");
        const { width, height } = imageDimensions; // Destructure imageDimensions for clarity
        const tileSource = isDziURL
            ? {
                Image: {
                    xmlns: "http://schemas.microsoft.com/deepzoom/2008",
                    Url: encodeURI(dziUrl),
                    Format: "jpeg",
                    Overlap: 2,
                    TileSize: 256,
                    Size: { Width: width, Height: height },
                },
            }
            : {
                type: "image",
                url: encodeURI(dziUrl),
                buildPyramid: false,
            };
        const osdViewer = OpenSeadragon({
            id: "openseadragon-viewer",
            prefixUrl: "https://openseadragon.github.io/openseadragon/images/",
            tileSources: tileSource,
            showNavigator: true,
            crossOriginPolicy: "Anonymous",
            navigatorPosition: "BOTTOM_RIGHT",
            maxZoomPixelRatio: 10,
            minZoomImageRatio: 0.5,
            visibilityRatio: 1,
            zoomPerScroll: 2,
            homeFillsViewer: true,
            gestureSettingsMouse: {
                clickToZoom: true,
                dblClickToZoom: true,
                flickEnabled: true,
                pinchToZoom: true,
                scrollToZoom: true,
            },
            showZoomControl: true,
            showHomeControl: true,
            showFullPageControl: true,
            showRotationControl: true,
            wrapHorizontal: false,
        });

        setViewer(osdViewer);

        return () => {
            if (osdViewer) {
                osdViewer.destroy();
            }
        };
    }, [dziUrl, imageDimensions]);


    useEffect(() => {
        GetQuizResult();
    }, [])


    const closeDeepZoom = () => {
        setPopupOpen(false);
        setDziUrl("");
        setDziUrlFile("");
        setImageDimensions({ width: 0, height: 0 });
        if (viewer) {
            viewer.destroy();
            setViewer(null);
        }
    };


    useEffect(() => {
        if (currentImage) {
            const img = new Image();
            img.src = `${imageCloudfront}${currentImage?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`;
            img.onload = () => setIsLoading(false);
        }

    }, [currentImage]);

    useEffect(() => {
        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
        }
    }, [window.site]);

    const handlePopupload = (e) => {
        setPopupLoading(true)
        console.log(dziUrl, "dz")
    }



    const [cancel, setCancel] = useState(false);

    // const handleSubmit2 = async (e) => {
    //     // Remove percentage validation: only require at least one answer selected per question
    //     const validated = cpcQtns.map((qtn, index) => {
    //         const selectedAnswers = qtn.answers.filter(ans =>
    //             Object.keys(ans.selected || {}).length > 0
    //         );
    //         const valid = selectedAnswers.length > 0;
    //         return {
    //             caseid: qtn.caseid,
    //             answers: selectedAnswers,
    //             title: 'Case ' + (index + 1),
    //             diagnosis: qtn.diagnosis,
    //             selectedCount: selectedAnswers.length,
    //             valid,
    //             index
    //         };
    //     });


    //     // Start loader
    //     setBtnLoader(true);

    //     try {
    //         let payload = {
    //             moduleid: id,
    //             userid: localStorage.getItem("userId"),
    //             cases: [],
    //             projection: "clientcase"
    //         };

    //         validated.forEach((caseData) => {
    //             let answers = caseData.answers.map(ans => ({
    //                 answerid: ans?.selected?.value,
    //                 answer: ans?.selected?.label
    //             }));

    //             payload.cases.push({
    //                 caseid: caseData.caseid,
    //                 answers: answers
    //             });
    //             payload["moduleType"] = moduleType
    //         });

    //         const res = await tmdbApi.updateLearningcParticipantAnswers(payload,state?.learninguniqueid);

    //         if (res.result?.message?.toLowerCase() === "answers submitted successfully") {
    //             setLearninguniqueid(res?.result?.learninguniqueid);
    //             setSuccessMsg(true);
    //         }

    //     } catch (error) {
    //         console.error("Submit Error:", error);
    //         setError(["Something went wrong. Please try again."]);
    //     } finally {
    //         // Stop loader always
    //         setBtnLoader(false);
    //     }
    // };

    const refresh = () => {

        // navigate("/modulesresult/" + learninguniqueid);
        navigate("/fellowshipmodules");
        setSuccessMsg(false)
    }
    const allAnswersFilled = () => {
        if (!quizResultData?.cases || quizResultData.cases.length === 0) return false;

        return quizResultData.cases.every(caseItem => {
            const answer = caseAnswers[caseItem.caseid];
            return answer && answer.trim() !== "";
        });
    };
    const ErrorList = ({ errors }) => {
        if (!errors || errors.length === 0) {
            return null; // No errors to display
        }

        return (
            <div style={{ color: 'red' }}>
                <ul style={{ display: "block" }}>
                    {errors.map((error, index) => (
                        <li key={index}>{error}</li>
                    ))}
                </ul>
            </div>
        );
    };

    useEffect(() => {
        console.log("Quiz Result Data:", quizResultData);
        console.log("Cases:", quizResultData?.cases);
        console.log("Case Answers State:", caseAnswers);
    }, [quizResultData, caseAnswers]);
    const handleSave = async (e) => {
        e.preventDefault();
        setSaveLoader(true);

        try {
            const payload = {
                moduleid: quizResultData?.moduleid,
                userid: quizResultData?.userid,
                cases: quizResultData?.cases.map(caseItem => ({
                    caseid: caseItem.caseid,
                    answers: [{
                        answerid: caseAnswers[caseItem.caseid] || "",
                        answer: caseAnswers[caseItem.caseid] || ""
                    }]
                })),
                projection: quizResultData?.projection,
                moduleType: quizResultData?.moduleType,
                submitted: false
            };

            const res = await tmdbApi.updateLearningcParticipantAnswers(payload, state?.learninguniqueid);
            console.log('resresresresresresresresres22222222222222222', res)
            if (res.result?.message?.includes("Updated successfully")) {
                // Show success message
                toast.success("Saved Successfully")
                setTimeout(() => {
                    navigate('/fellowshipmodules')

                }, 3000);
                console.log("Saved successfully");
            }
        } catch (error) {
            console.error("Save Error:", error);
            setError(["Something went wrong. Please try again."]);
        } finally {
            setSaveLoader(false);
        }
    };
    console.log('quixxxxxxxxxxxxxxxxx', error)




    const handleConfirmSubmit = (e) => {
        e.preventDefault();

        // ✅ Validate answers first
        if (!allAnswersFilled()) {
            toast.error("Please answer all cases before submitting.");
            return;
        }

        // ✅ Validation passed → show confirmation popup
        setConfirmPopup(true);
    };

    const handleSubmit = async () => {

        console.log("All Answers Filled:", allAnswersFilled()); // Debug log
        console.log("Case Answers:", caseAnswers); // Debug log

        if (!allAnswersFilled()) {
            toast.error("Please answer all cases before submitting.");
            return;
        }

        setSubmitLoader(true);

        try {
            const payload = {
                moduleid: quizResultData?.moduleid,
                userid: quizResultData?.userid,
                cases: quizResultData?.cases.map(caseItem => ({
                    caseid: caseItem.caseid,
                    answers: [{
                        answerid: caseAnswers[caseItem.caseid],
                        answer: caseAnswers[caseItem.caseid]
                    }]
                })),
                projection: quizResultData?.projection,
                moduleType: quizResultData?.moduleType,
                submitted: true,
                pathologistid: state?.pathologistid

            };
            // if(state?.pathologistid && payload.submitted === true){
            //     payload["pathologistid"]= state?.pathologistid
            // }

            console.log('payloaddddddddddddddddddddddddddddddddddd', payload)

            const res = await tmdbApi.updateLearningcParticipantAnswers(payload, state?.learninguniqueid);
            console.log('resresresresresresresresres', res)

            if (res.result?.message?.toLowerCase().includes("success")) {
                setLearninguniqueid(res?.result?.learninguniqueid);
                setSuccessMsg(true);
                // setTimeout(() => {
                //     navigate('/fellowshipmodules')

                // }, 3000);
            }
        } catch (error) {
            console.error("Submit Error:", error);
            setError(["Something went wrong. Please try again."]);
        } finally {
            setSubmitLoader(false);
        }
    };
    const getFeedbackAPI = async (caseid) => {
        setFeedbackLoading(true);
        try {
            const response = await tmdbApi.getFeedbackApi(caseid, quizResultData?.moduleid, "client");
            if (response?.result) {
                const data = response.result[0] ?? null;
                setFeedBackData(data);
                // setText only after we set the data, to avoid flicker
                setFeedbackText(data?.feedbackDescription ?? "");
            } else {
                setFeedBackData(null);
                setFeedbackText("");
            }
        } catch (err) {
            console.error("getFeedbackAPI error:", err);
            setFeedBackData(null);
            setFeedbackText("");
        } finally {
            setFeedbackLoading(false);
        }
    };

    const GetQuizResult = async () => {
        setLoader(true)
        // console.log('setcontentLoadedsetcontentLoadedsetcontentLoaded', id)
        try {
            const response = await tmdbApi.quizInfo(state?.learninguniqueid);
            const allCases = response?.result?.[0] || [];



            console.log('all cases', allCases)

            setQuizResultData(allCases);


            // setcontentLoaded(true);
        } catch (err) {
            console.log("error", err);
            // setcontentLoaded(true);
        } finally {
            setLoader(false)
        }
    };





    const handlePngPopupImage = (imageUrl) => {
        setShowImagePopup(true)
        setPopupPngImage(imageUrl)
    }


    const [videoUrl, setVideoUrl] = useState(null);

    const getYouTubeVideoId = (url) => {
        const regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
        const match = url?.match(regExp);
        return match && match[7].length === 11 ? match[7] : null;
    };



    console.log('moduletypeeeeeeeeeeee', moduleType)

    const handleFeedBackPopup = (item) => {
        setActiveCaseId(item.caseid);
        // clear previous data so UI doesn't show stale values while fetching
        setFeedBackData(null);
        setFeedbackText("");
        setActiveFeedbackModal(true);
        getFeedbackAPI(item.caseid);
    };
    useEffect(() => {
        if (feedBackData) {
            // ensure we only update text if not currently fetching (guard)
            if (!feedbackLoading) {
                setFeedbackText(feedBackData.feedbackDescription ?? "");
            }
        }
    }, [feedBackData, feedbackLoading]);
    return (
        <div id="layout-wrapper" className="module-quiz-db">
            <Header />
            <SideMenu />


            <div className="main-content user-management quiz-page" id="main-content">
                <div className="page-content" id="page-content">
                    <div className="container-fluid" id="container-fluid">
                        <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                            <div className="col-lg-12">
                                <div className="d-flex align-items-start gap-5">
                                    <div className="flex-grow-1 d-grid gap-2">

                                    </div>
                                    <div className="create-quiz-btn" onClick={() => { navigate("/fellowshipmodules") }}>
                                        Back
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 d-flex justify-content-between flex-wrap case-main-heading">

                                <div className="col-lg-8 col-md-8 col-12">
                                    <h4 className="mb-2 card-title" id="breadcrumb-title">
                                        {quizResultData?.moduleName}
                                    </h4>
                                    <p className="mb-0" dangerouslySetInnerHTML={{ __html: quizResultData?.moduledescription }}></p>

                                </div>
                                {videoUrl && <>
                                    <div className="col-lg-3 col-md-3 col-12">
                                        <h2 className="quiz-title">Video</h2>

                                        <div className="video-card">
                                            <img src={videoUrl ? `https://img.youtube.com/vi/${getYouTubeVideoId(videoUrl)}/0.jpg` : `https://img.youtube.com/vi/0.jpg`} alt="Thumbnail" />
                                            <button className="play-btn" >
                                                <span className="material-symbols-outlined" style={{ cursor: "pointer" }}
                                                    onClick={() => setShowVideoPopup(true)}>
                                                    play_arrow
                                                </span>
                                            </button>
                                        </div>

                                    </div>
                                    <div className="cpcquiz-line1"></div>
                                </>}
                            </div>


                        </div>

                        <div className="row table-data">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-body cpc-management">

                                        <div className="wrapper client_wrapper mt-3 pt-3">
                                            <div className="wrapper quiz_page view-history-page">


                                                <div className="question_block quiz-page">


                                                    {
                                                        loader ? <Loader /> :
                                                            quizResultData?.cases && (
                                                                <div className="mb-4">
                                                                    {quizResultData.cases.map((caseItem, qIndex) => {
                                                                        // const userAnswer = caseItem.answers.find(ans => ans.hasOwnProperty('isCorrect'));
                                                                        // const isCorrectAnswer = userAnswer?.isCorrect === true;
                                                                        // console.log('caseItem-->',caseItem)
                                                                        return (
                                                                            <div key={qIndex} className="mb-4 case-block">
                                                                                <div className="cpcquiz-ques">
                                                                                    <div className="row justify-content-between align-items-start col-lg-12 quiz-ques-img-case">
                                                                                        <div className="d-flex flex-column col-lg-8 quiz-ques-sect">
                                                                                            <div className="d-flex justify-content-between gap-1 align-items-start">
                                                                                                <h3 className="quiz-title">Case {qIndex + 1}  </h3>

                                                                                            </div>
                                                                                            <div>
                                                                                                <p className="mb-0" dangerouslySetInnerHTML={{ __html: caseItem?.caseDetails?.clinicalhistory }} />

                                                                                            </div>
                                                                                            <p className="col-lg-12 quiz-para" dangerouslySetInnerHTML={{ __html: caseItem?.clinicalhistory }} />
                                                                                            <div>

                                                                                                <div className="case-answer-section">
                                                                                                    <div className="question_block p-0 mt-0">
                                                                                                        <div className="result_table cpc-fb-sec-table">



                                                                                                            <div className="">

                                                                                                                {/* Heading */}
                                                                                                                <div className="row fw-semibold py-1">
                                                                                                                    <div className="col-12 case-answer-heading">
                                                                                                                        ANSWER :
                                                                                                                    </div>
                                                                                                                </div>


                                                                                                                <div style={{ display: "flex", alignItems: "center", gap: "10px", marginBottom: "10px" }}>
                                                                                                                    <div style={{ position: "relative", flex: 1 }}>
                                                                                                                        <textarea
                                                                                                                            type="text"
                                                                                                                            className="text-input module-quiz-textarea"
                                                                                                                            placeholder="Type your answer"
                                                                                                                            value={caseAnswers[caseItem.caseid] || ""}
                                                                                                                            onChange={(e) => handleTextInputChange(caseItem.caseid, e.target.value)}
                                                                                                                            style={{
                                                                                                                                width: "100%",
                                                                                                                                padding: "8px 30px 8px 8px",
                                                                                                                                borderRadius: "4px",
                                                                                                                                fontSize: "14px"
                                                                                                                            }}
                                                                                                                        />


                                                                                                                    </div>
                                                                                                                </div>
                                                                                                            </div>



                                                                                                        </div>
                                                                                                    </div>



                                                                                                </div>

                                                                                                <div>

                                                                                                </div>








                                                                                            </div>
                                                                                        </div>
                                                                                        <div className="col-lg-4 quiz-img-section view-history-img-section">
                                                                                            <div className="quiz-img">



                                                                                            </div>
                                                                                            <div className={caseItem?.caseDetails?.files?.length > 0 ? "quiz_info content" : "quiz_info no-image content"}>

                                                                                                <div className="d-grid justify-content-start gap-2 align-items-center">
                                                                                                    <div className="img-wrapper">
                                                                                                        {caseItem?.caseDetails?.files && caseItem?.caseDetails?.files.length > 0 && <p className="mt-2">Histological Photos</p>}
                                                                                                        <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper"> {caseItem?.caseDetails?.files?.map((file, fileIndex) => (
                                                                                                            <div key={fileIndex}

                                                                                                                className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                                onClick={(e) => {
                                                                                                                    let filepath = file?.sourcepath || file?.filepath || "";
                                                                                                                    let imagePath = `${imageCloudfront}${filepath && filepath?.replace(/ /g, "%20")}?auto=compress,format`

                                                                                                                    //handlePopupImage(imagePath)
                                                                                                                    setPopupOpen(true);
                                                                                                                    setImageDimensions({ width: file.width, height: file.height });

                                                                                                                    let path = file.dziUrl || "";
                                                                                                                    if (path.startsWith("/")) path = path.slice(1);
                                                                                                                    let isDziURL = path.includes("output.dzi");
                                                                                                                    if (isDziURL) {
                                                                                                                        path = `${path}_files/`;
                                                                                                                        setDziUrl(imageCloudfront + path);
                                                                                                                    } else {
                                                                                                                        setDziUrl(imagePath);
                                                                                                                    }

                                                                                                                    setDziUrlFile(file?.originalFilename ? file?.originalFilename : file.filename)
                                                                                                                    setDZIPopupImage(imageCloudfront + file.sourcepath);
                                                                                                                    handlePopupload(e);

                                                                                                                }}
                                                                                                            >
                                                                                                                <span className="material-symbols-outlined img_view">zoom_out_map</span>

                                                                                                                <span className="default-img">

                                                                                                                    <img src={file?.thumbnailUrl ? imageCloudfront?.replace(/\/$/, "") + file?.thumbnailUrl + "?auto=compress,format&width=150" : (

                                                                                                                        file?.sourcepath ? `${imageCloudfront}${file?.sourcepath && file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format` : deepZoom
                                                                                                                    )} alt={file?.originalFilename} />

                                                                                                                </span>
                                                                                                            </div>

                                                                                                        ))}</div>

                                                                                                    </div>

                                                                                                    <div className="img-wrapper">
                                                                                                        {caseItem?.caseDetails?.historyfiles && caseItem?.caseDetails?.historyfiles.length > 0 &&
                                                                                                            <p>Clinical History Photos</p>}
                                                                                                        <div className="img_block d-flex mod-lib-clinic-history-img cpc-info-img-wrapper">
                                                                                                            {caseItem?.caseDetails?.historyfiles && caseItem?.caseDetails?.historyfiles.length > 0 && caseItem?.caseDetails?.historyfiles?.map((file, key) => {

                                                                                                                let imagePath = `${imageCloudfront}${file?.sourcepath && file?.sourcepath.replace(/ /g, "%20")}?auto=compress,format`

                                                                                                                return (

                                                                                                                    <div
                                                                                                                        key={key}
                                                                                                                        className={`img me-2 ${!file?.thumbnailUrl ? 'upload-static-img' : ''}`}
                                                                                                                        style={{ width: 'auto' }}
                                                                                                                        onClick={(e) => handlePngPopupImage(imagePath)}
                                                                                                                    >
                                                                                                                        <span className="material-symbols-outlined img_view img-zoom">zoom_out_map</span>
                                                                                                                        <img
                                                                                                                            src={`${imageCloudfront}${file?.sourcepath?.replace(/ /g, "%20")}?auto=compress,format&width=125`}
                                                                                                                            alt={`Image ${key + 1}`}
                                                                                                                            loading="lazy"
                                                                                                                        />
                                                                                                                    </div>


                                                                                                                )
                                                                                                            })}
                                                                                                        </div>
                                                                                                    </div>

                                                                                                    <div className="cpcquiz-line">
                                                                                                    </div>
                                                                                                </div>

                                                                                            </div>
                                                                                        </div>

                                                                                    </div>


                                                                                </div>
                                                                            </div>
                                                                        )
                                                                    })}
                                                                </div>
                                                            )
                                                    }



                                                    {/* {error.length > 0 && <ErrorList errors={error} />} */}
                                                    {/* <div className="btns quiz-form-btns">
                                                        <button type="submit" className="create-quiz-btn border-0 mr-10" onClick={(e) => handleSubmit(e)}>Save</button>
                                                        <button type="submit" className="create-quiz-btn border-0 mr-10" onClick={(e) => handleSubmit(e)}>Submit</button>
                                                        <button type="submit" className="fw-normal outline_btn reset-quiz-btn mr-10" onClick={(e) => onReset(e)}>Reset</button>
                                                        <button type="submit" className="fw-normal outline_btn reset-quiz-btn mr-10" onClick={(e) => setCancel(true)}>Cancel</button>
                                                    </div> */}

                                                    <div className="btns quiz-form-btns">
                                                        <button
                                                            type="submit"
                                                            className="create-quiz-btn border-0 mr-10"
                                                            onClick={(e) => handleSave(e)}
                                                            disabled={saveLoader || submitLoader}
                                                        >
                                                            {saveLoader ? "Saving..." : "Save as draft"}
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            className="create-quiz-btn border-0 mr-10"
                                                            onClick={handleConfirmSubmit}
                                                            disabled={saveLoader || submitLoader}
                                                        >
                                                            {submitLoader ? "Submitting..." : "Submit"}
                                                        </button>
                                                        <button
                                                            type="submit"
                                                            className="fw-normal outline_btn reset-quiz-btn mr-10"
                                                            onClick={(e) => onReset(e)}
                                                            disabled={saveLoader || submitLoader}
                                                        >
                                                            Reset
                                                        </button>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>

            {isPopupOpen && !dziUrl && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100vw",
                        height: "100vh",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        zIndex: 999,
                    }}
                    onClick={() => setPopupOpen(false)}
                >
                    <div className="popup_wrp"
                        style={{
                            position: "relative",
                            background: "white",
                            padding: "10px",
                            borderRadius: "10px",
                            maxWidth: "90vw",
                            maxHeight: "90vh",

                        }}
                        onClick={(e) => e.stopPropagation()}
                    >
                        {/* Close Button */}
                        <button
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                background: "white",
                                color: "#000",
                                border: "none",

                                cursor: "pointer",
                                borderRadius: "5px",
                            }}
                            onClick={() => setPopupOpen(false)}
                        >
                            <span className="material-symbols-outlined">
                                X
                            </span>
                        </button>

                        {/* Zoomable Image */}
                        <TransformWrapper ref={transformRef} initialScale={1}>
                            <div style={{ textAlign: "left", marginBottom: "10px" }}>
                                <button onClick={() => transformRef.current.zoomIn()} className="btnzoom" ><span className="material-symbols-outlined"> add </span></button>
                                <button onClick={() => transformRef.current.zoomOut()} className="btnzoom"><span className="material-symbols-outlined"> remove </span></button>
                                {/* <button onClick={() => transformRef.current.resetTransform()} className="btnzoom"><span className="material-symbols-outlined"> refresh </span></button> */}
                            </div>

                            <TransformComponent>


                                {isPopupLoading && <div style={{ width: "400px", height: "400px" }}><Loader /> </div>}

                                <LazyLoadImage
                                    src={popupImage + `? auto = compress, format`}
                                    effect="blur"
                                    onLoad={() => setPopupLoading(false)}
                                    style={{ width: "100%", borderRadius: "10px" }}
                                    alt="Popup Image"
                                />

                            </TransformComponent>
                        </TransformWrapper>
                    </div>
                </div>
            )}

            {/* Deep Zoom Popup */}
            {isPopupOpen && dziUrl && (
                <div className="deep_zoom">
                    <div
                        style={{
                            position: "fixed",
                            top: '0',
                            left: '0',
                            right: '0',
                            bottom: '0',
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "center",
                            zIndex: 999,
                            borderRadius: "18px"
                        }}
                    >
                        <div style={{
                            width: "98vw",
                            height: "98vh",
                            position: "relative",
                            backgroundColor: "black",
                            overflow: "hidden"
                        }}>
                            {/* Deep Zoom Header */}
                            <div style={{
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center",
                                padding: "10px 20px",
                                backgroundColor: "#f8f9fa",
                                borderBottom: "1px solid #dee2e6"
                            }}>
                                <h3 style={{ fontSize: "18px" }}>

                                </h3>
                                <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>

                                    <button
                                        className="dz_close"
                                        onClick={closeDeepZoom}
                                        style={{
                                            position: "absolute",
                                            top: 10,
                                            right: 10,
                                            cursor: "pointer",
                                            borderRadius: "6px",
                                        }}
                                    >
                                        <span className="material-symbols-outlined">close</span>
                                    </button>

                                </div>
                            </div>

                            {/* Deep Zoom Viewer Container */}
                            <div style={{
                                height: "calc(95vh - 80px)",
                                width: "100%",
                                position: "relative"
                            }}>
                                <div
                                    id="openseadragon-viewer"
                                    ref={viewerRef}
                                    style={{
                                        height: "100%",
                                        width: "100%"
                                    }}
                                />


                            </div>
                        </div>
                    </div>
                </div>
            )}




            {showImagePopup && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => setShowImagePopup(false)}
                >
                    <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                        <img src={popupPngImage} className="modal-img" alt="Popup" />

                        <button
                            className="dz_close"
                            onClick={() => setShowImagePopup(false)}
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                cursor: "pointer",
                                borderRadius: "6px",
                            }}
                        >
                            <span className="material-symbols-outlined">close</span>
                        </button>

                    </div>
                </div>
            )}

            <SweetAlert show={confirmPopup}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure you want to submit this module? It cannot be modified after submission."
                focusCancelBtn
                onConfirm={e => onConfirmPopup()}
                onCancel={e => onCancelConfirm()}
            ></SweetAlert>
            <SweetAlert show={resetpopup}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure to reset the answers?"
                focusCancelBtn
                onConfirm={e => onResetConfirm()}
                onCancel={e => onResetReject()}
            ></SweetAlert>

            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />
            <SweetAlert
                show={successMsg}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Submitted Successfully. The pathologist will review and follow up with you"}
                onConfirm={e => refresh()}
                id="error-alert"
            ></SweetAlert>

            {showVideoPopup && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.8)",
                        zIndex: 1000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                    onClick={() => setShowVideoPopup(false)}
                >
                    <div style={{ position: "relative", width: "80%", maxWidth: "800px" }}>
                        <iframe
                            width="100%"
                            height="450"
                            src={`https://www.youtube.com/embed/${getYouTubeVideoId(
                                videoUrl
                            )}`}
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                            title="Video Preview"
                        ></iframe>
                        <button className="create-quiz-btn"
                            onClick={() => setShowVideoPopup(false)}
                            style={{
                                position: "absolute",
                                top: 10,
                                right: 10,
                                border: "none",
                                cursor: "pointer",
                            }}
                        >
                            X
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};



export default EditFellowshipModule;